export class PlanogramConstants
{
    /**
     * The intrinsic height of a shelf in centimetres
    */
    static readonly SHELF_INTRINSIC_HEIGHT: number = 1;

    /**
     * Default drop height in millimeters if none is specified
     */
    static readonly DEFAULT_DROP_HEIGHT: number = 195;

    /**
     * Default drop footer height in millimeters if none is specified
     */
    static readonly DEFAULT_DROP_FOOTER_HEIGHT: number = 20;

    /**
     * Default shelf width in millimeters if none is specified
     */
    static readonly DEFAULT_SHELF_WIDTH: number = 91;

    /**
     * Default shelf depth in millimeters if none is specified
     */
    static readonly DEFAULT_SHELF_DEPTH: number = 38;
}